import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { spacing8, spacing24 } from 'approot/shared/styles/spacing.style';
import { ColourItem } from 'approot/shared/colour/colour-token.style';
import { borderRadius8 } from 'approot/shared/styles/borders.style';

type ComponentWrapperProps = {
  $marginBottom?: number;
  $colours?: ColourItem | null;
  $showBackground?: boolean;
  $showBorder?: boolean;
};
export const ComponentViewWrapper = styled.div<ComponentWrapperProps>`
  position: relative;
  margin-bottom: ${({ $marginBottom = spacing24 }) => rem($marginBottom)};

  ${({ $colours, $showBackground }) =>
    $colours &&
    $showBackground &&
    `
    background-color: ${$colours.colour1};
    padding: ${rem(spacing8)};
    border-radius: ${rem(borderRadius8)};
  `}

  ${({ $colours, $showBorder }) =>
    $colours &&
    $showBorder &&
    `
    border: 1px solid ${$colours.colour3};
    padding: ${rem(spacing8)};
    border-radius: ${rem(borderRadius8)};
  `}
`;
